


export enum SearchTypes {
	searchAll = 'SearchAll',
	searchCustomers = 'SearchCustomers',
	searchOrders = 'SearchOrders',
	searchShipments = 'SearchShipments',
}


export const isSearchTypes = (value: unknown): value is SearchTypes => {
	const enumValues = Object.values(SearchTypes);
	return typeof value === 'string' && enumValues.includes(value as SearchTypes);
};